import React, { useEffect, useState, useContext } from "react";
import { Toaster, toast } from "sonner";
import "./pages.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonLoader from "../../../loader/CommonLoader";
import axiosInstance from "../../../refershTokenManage/axiosConfig";
import { Link } from "react-router-dom";
import PaginationComponent from "../common-components/pagination/PaginationComponent";
import TikTokAccountFilters from "./component/TikTokAccountFilters";
import { Button } from "react-bootstrap";
import { colors } from "../../../utils/constants";
import { Bar } from "react-chartjs-2";
import moment from "moment/moment";
import { FaTiktok } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { LoginContext } from "../../../App";
import CustomCard from "../common-components/cardWrapper";
import { truncateString } from "../../../utils/helperfunctions";
import NoDataFoundPage from "../common-components/NoDataFound";
import CustomModal from "../common-components/customModal";
import { MultiSelect } from "react-multi-select-component";
import { hasPermission } from "../../../helperPermissionEditor";
import TagBadges from "../common-components/TagBadge";


const TikTokIndex = () => {
  const [accounts, setAccounts] = useState([]),
    [isLoading, setLoading] = useState(false),
    [graphLoading, setGraphLoading] = useState(false),
    [error, setError] = useState(null),
    [pagination, setPagination] = useState([]),
    [currentPage, setCurrentPage] = useState(1),
    [totalPages, setTotalPages] = useState(1),
    [pageStart, setPageStart] = useState(1),
    [filters, setFilters] = useState({
      client_id: null,
      follower_count_from: "",
      follower_count_to: "",
      following_count_from: "",
      following_count_to: "",
      total_favorited_from: "",
      total_favorited_to: "",
      visible_videos_count_from: "",
      visible_videos_count_to: "",
      from: "",
      to: "",
      sort_by: "average_views",
      order_by: null,
      column_sort: "",
    }),
    [clients, setClients] = useState([]),
    [record, setRecord] = useState({
      visible: false,
      clients: [],
    }),
    [sortConfig, setSortConfig] = useState({ key: null, direction: null }),
    [chartsData, setChartData] = useState({
      views: [],
      names: [],
      fullName: {},
      images: [],
    }),
    [chartsDataInteractions, setChartDataInteractions] = useState({
      interactions: [],
      names: [],
      fullName: {},
      images: [],
    }),
    [chartsDataEngagements, setChartDataEngagements] = useState({
      engagements: [],
      names: [],
      fullName: {},
      images: [],
    }),
    { user, theme, fullScreen } = useContext(LoginContext),
    [filterModal, setFilterModal] = useState(false),
    [topAccountsAPIResponse, setTopAccountsAPIResponse] = useState(0);


  const textColor = theme === "dark" ? "#ffffff" : "#000000";

  const fetchTikTok = async (page = 1) => {
    setLoading(true);
    if (filters) {
      setFilterModal(false);
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.post(
        `/api/tiktok/accounts?page=${page}`,
        filters,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (
        !response.data ||
        !response.data.data ||
        response.data.data.length === 0
      ) {
        setAccounts([]);
        setPagination({});
        setCurrentPage(1);
        setTotalPages(1);
        setLoading(false);
        return;
      }

      const localAccounts = response.data.data.map((account) => {
        return {
          ...account.tiktok_account,
          views: Number(account.average_views),
          interactions: Number(account.average_interactions),
          engagement: Number(account.average_engagement),
        };
      });
      const images = localAccounts.map((img) => img.avatar);

      setAccounts(localAccounts);
      const { pagination: apiPagination } = response.data;
      setPagination(apiPagination);
      setCurrentPage(apiPagination.current_page);
      setTotalPages(apiPagination.last_page);
    } catch (err) {
      setAccounts([]);
      setPagination({});
      setCurrentPage(1);
      setTotalPages(1);
      setError("Failed to fetch TikTok Accounts");
    } finally {
      setLoading(false);
    }
  };

  const getTopFiveAccounts = async () => {
    setGraphLoading(true);
    const token = localStorage.getItem("token");

    const response = await axiosInstance.post(
      `/api/tiktok/top-accounts`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;

    if (
      !data ||
      !data.top_by_views ||
      data.top_by_views.length === 0
    ) {
      setChartData({
        views: [],
        names: [],
        fullName: {},
        images: [],
      });
      setChartDataInteractions({
        interactions: [],
        names: [],
        fullName: {},
        images: [],
      });
      setChartDataEngagements({
        engagements: [],
        names: [],
        fullName: {},
        images: [],
      });
      setGraphLoading(false);
      return;
    }

    const views = [], viewNames = [], viewFullName = {}, viewImages = [];
    data.top_by_views.forEach(account => {
      const label = account.nickname;
      views.push(Number(account.average_views));
      viewNames.push(label);
      viewFullName[label] = account.nickname;
      viewImages.push(account.avatar);
    });

    setChartData({
      views,
      names: viewNames,
      fullName: viewFullName,
      images: viewImages,
    });

    const interactions = [], interactionNames = [], interactionFullName = {}, interactionImages = [];
    data.top_by_interactions.forEach(account => {
      const label = account.nickname;
      interactions.push(Number(account.average_interactions));
      interactionNames.push(label);
      interactionFullName[label] = account.nickname;
      interactionImages.push(account.avatar);
    });

    setChartDataInteractions({
      interactions,
      names: interactionNames,
      fullName: interactionFullName,
      images: interactionImages,
    });

    const engagements = [], engagementNames = [], engagementFullName = {}, engagementImages = [];
    data.top_by_engagement.forEach(account => {
      const label = account.nickname;
      engagements.push(Number(account.average_engagement));
      engagementNames.push(label);
      engagementFullName[label] = account.nickname;
      engagementImages.push(account.avatar);
    });

    setChartDataEngagements({
      engagements,
      names: engagementNames,
      fullName: engagementFullName,
      images: engagementImages,
    });
    setTopAccountsAPIResponse(1);
    setGraphLoading(false);
  };

  // Charts
  const generateChartData = (label, content, chartImages, chartNames) => {
    const data = {
      labels: chartNames.slice(0, 5),
      datasets: [
        {
          label: label,
          data: content.slice(0, 5),
          backgroundColor: Object.values(colors),
          borderColor: Object.values(colors),
          borderWidth: 2,
          pointRadius: 3,
          pointBackgroundColor: Object.values(colors),
          image: chartImages.slice(0, 5),
        },
      ],
    };
    return data;
  };

  const options = {
    responsive: true,
    layout: {
      padding: {
        top: 30,
      },
    },
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        ticks: {
          color: textColor,
          callback: function (value, index, ticks) {
            const totalTicks = ticks.length;
            const interval = Math.floor(totalTicks / 5);
            if (index % interval === 0 || index === totalTicks - 1) {
              return truncateString(this.getLabelForValue(value), 8);
            }
            return '';
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: textColor,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: false,
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "black",
        bodyColor: "black",
      },
      title: {
        display: false,
      },
    },
  };

  const cachedImagesMap = new WeakMap();

  const imagePlugin = {
    id: "imagePlugin",

    beforeInit(chart) {
      const cachedImages = [];
      const dataset = chart.data.datasets[0];

      if (!dataset.image || !Array.isArray(dataset.image)) return;

      dataset.image.forEach((src, index) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = src;

        img.onload = () => {
          cachedImages[index] = img;
          chart.update();
        };
      });
      cachedImagesMap.set(chart, cachedImages);
    },
    afterDatasetsDraw(chart) {
      const cachedImages = cachedImagesMap.get(chart);
      if (!cachedImages) return;

      const { ctx } = chart;
      const meta = chart.getDatasetMeta(0);

      meta.data.forEach((bar, index) => {
        const img = cachedImages[index];
        if (!img) return;

        const xPos = bar.x - 15;
        const yPos = bar.y - 35;
        const radius = 17;

        ctx.save();
        ctx.beginPath();
        ctx.arc(xPos + radius, yPos + radius, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, xPos, yPos, 50, 50);
        ctx.restore();
      });
    },
  };

  useEffect(() => {
    fetchTikTok(currentPage);
    if (topAccountsAPIResponse === 0) { getTopFiveAccounts(); }
  }, [currentPage, filters]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    const newPageStart = Math.floor((page - 1) / 5) * 5 + 1;
    setPageStart(newPageStart);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  useEffect(() => {
    getClients();
  }, []);

  const getClients = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axiosInstance.get(`/api/dashboard/clients`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const localClients = response.data.clients?.map((client) => ({
          name: client.name,
          id: client.id,
        }));
        setRecord({
          ...record,
          visible: true,
        });
        setClients(localClients);
      }
    } catch (error) {
      console.error("Error fetching record for edit:", error);
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setFilters({
      ...filters,
      column_sort: key,
      order_by: direction,
    });
    setSortConfig({ key, direction });
  };

  const getArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return null;
  };

  return (
    <div className="clientLists userLists">
      {isLoading && (
        <div className="loader-overlay">
          <CommonLoader />
        </div>
      )}

      <div className="mt-3">
        <div className="userFetchData">
          <div className="userDetails">
            <div style={{ display: "flex" }}>
              <h1 className="bold fs-4 mb-0 me-4">TikTok Analytics</h1>
              <div>
                <Button
                  variant="primary"
                  onClick={() => {
                    setFilterModal(true);
                  }}
                >
                  Filters
                </Button>
              </div>
            </div>

            {graphLoading ? (
              <div className="loader-overlay">
                <CommonLoader />
              </div>
            ) : (
              <div className="row mt-3 p-0">
                <div className="col-12 col-lg-4 my-2">
                  <CustomCard header="Top 5 Average Views" id="average-views">
                    <div
                      className="chart-wrapper"
                      style={{
                        minWidth: "150px",
                        height: fullScreen ? "90%" : "250px",
                        overflowX: "auto",
                      }}
                    >
                      {chartsData?.views?.length > 0 ? (
                        <Bar
                          data={generateChartData(
                            "Average View",
                            chartsData.views,
                            chartsData.images,
                            chartsData.names
                          )}
                          options={options}
                          plugins={[imagePlugin]}
                        />
                      ) : (
                        <p>No user statistics available.</p>
                      )}
                    </div>
                  </CustomCard>
                </div>

                <div className="col-12 col-lg-4 my-2">
                  <CustomCard header="Top 5 Average Interactions" id="average-interactions">
                    <div
                      className="chart-wrapper"
                      style={{
                        minWidth: "150px",
                        height: fullScreen ? "90%" : "250px",
                        overflowX: "auto",
                      }}
                    >
                      {chartsDataInteractions?.interactions?.length > 0 ? (
                        <Bar
                          data={generateChartData(
                            "Average Interactions",
                            chartsDataInteractions.interactions,
                            chartsDataInteractions.images,
                            chartsDataInteractions.names
                          )}
                          options={options}
                          plugins={[imagePlugin]}
                        />
                      ) : (
                        <p>No user statistics available.</p>
                      )}
                    </div>
                  </CustomCard>
                </div>

                <div className="col-12 col-lg-4 my-2">
                  <CustomCard header="Top 5 Engagements %" id="engagements">
                    <div
                      className="chart-wrapper"
                      style={{
                        minWidth: "150px",
                        height: fullScreen ? "90%" : "250px",
                        overflowX: "auto",
                      }}
                    >
                      {chartsDataEngagements?.engagements?.length > 0 ? (
                        <Bar
                          data={generateChartData(
                            "Engagement",
                            chartsDataEngagements.engagements,
                            chartsDataEngagements.images,
                            chartsDataEngagements.names
                          )}
                          options={options}
                          plugins={[imagePlugin]}
                        />
                      ) : (
                        <p>No user statistics available.</p>
                      )}
                    </div>
                  </CustomCard>
                </div>
              </div>
            )}

            <div className="mt-4">
              <div className="rounded overflow-hidden shadow">
                <div class="border-0 table-container sm-table table-responsive">
                  <table
                    className={`table-responsive table table-bordered table-striped overflow-auto table-hover${theme === "dark" ? " dark-table" : ""
                      }`}
                  >
                    <thead>
                      <tr style={{ position: "sticky", top: "0px" }}>
                        <th>Avatar</th>
                        <th>Unique ID</th>
                        <th>Nickname</th>
                        <th>Client</th>
                        <th
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSort("follower_count")}
                        >
                          Follower Count &nbsp;
                          {getArrow("follower_count")}
                        </th>
                        <th
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSort("following_count")}
                        >
                          Following Count &nbsp;
                          {getArrow("following_count")}
                        </th>
                        <th
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSort("total_favorited")}
                        >
                          Total Favorited &nbsp;
                          {getArrow("total_favorited")}
                        </th>
                        <th
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSort("visible_videos_count")}
                        >
                          Visible Videos &nbsp;
                          {getArrow("visible_videos_count")}
                        </th>
                        <th style={{ cursor: "pointer" }}
                          onClick={() => handleSort("average_views")}>Avg. View &nbsp; {getArrow("average_views")}</th>
                        <th style={{ cursor: "pointer" }} onClick={() => handleSort("average_interactions")}>Avg. Interactions &nbsp; {getArrow("average_interactions")}</th>
                        <th style={{ cursor: "pointer" }} onClick={() => handleSort("average_engagement")}>Engagement &nbsp; {getArrow("average_engagement")}</th>
                        <th>Updated At</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {accounts.length > 0 ? (
                        accounts.map((account, index) => (
                          <tr key={index}>
                            <td data-th="Avatar">
                              <img
                                src={account.avatar}
                                alt={account.nickname}
                                width="50"
                                height="50"
                                style={{ borderRadius: "50%" }}
                              />
                            </td>
                            <td
                              data-th="Unique ID"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.unique_id}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              <Link
                                to={`/Tiktok-statistics/${account?.tiktok_id}`}
                              >
                                {account.unique_id}
                              </Link>
                            </td>
                            <td
                              data-th="Nickname"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.nickname}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.nickname}
                            </td>
                            <td
                              data-th="Client"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.client}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.client}
                            </td>
                            <td
                              data-th={`Follower Count${getArrow("follower_count") ? ` ${getArrow("follower_count")}` : ""}`}
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.follower_count}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.follower_count}
                            </td>
                            <td
                              data-th={`Following Count${getArrow("following_count") ? ` ${getArrow("following_count")}` : ""}`}
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.following_count}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.following_count}
                            </td>
                            <td
                              data-th={`Total Favorited${getArrow("total_favorited") ? ` ${getArrow("total_favorited")}` : ""}`}
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.total_favorited}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.total_favorited}
                            </td>
                            <td
                              data-th={`Visible Videos${getArrow("visible_videos_count") ? ` ${getArrow("visible_videos_count")}` : ""}`}
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={
                                account.visible_videos_count
                              }
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.visible_videos_count}
                            </td>
                            <td
                              data-th="Avg. View"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.views}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.views}
                            </td>
                            <td
                              data-th="Avg. Interactions"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.interactions}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.interactions}
                            </td>
                            <td
                              data-th="Engagement"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={account.engagement}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {account.engagement}
                            </td>
                            <td
                              data-th="Updated At"
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content={moment(
                                account.updated_at
                              ).format("MMM Do YY")}
                              data-tooltip-place="bottom"
                            >
                              <ReactTooltip id={`tooltip-${index}`} />
                              {moment(account.updated_at).format("MMM Do YY")}
                            </td>
                            <td
                              data-tooltip-id={`tooltip-${index}`}
                              data-tooltip-content="Go to view profile"
                              data-tooltip-place="bottom"
                            >
                              <a
                                href={account.url}
                                className={theme === "dark" ? "dark-icon-hover" : ""}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <span>
                                  <FaTiktok />
                                </span>
                                <ReactTooltip id={`tooltip-${index}`} />
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            <NoDataFoundPage />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {accounts.length > 0 && totalPages > 1 && (
              <div className="pagination">
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                  pageStart={pageStart}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Filters Modal */}
      <CustomModal
        size="lg"
        show={filterModal}
        handleClose={() => setFilterModal(false)}
        headerContent={<h4>Filters</h4>}
        bodyContent={
          <TikTokAccountFilters
            parentFilters={filters}
            clients={clients}
            tagOptions={[]}
            onFilterChange={handleFilterChange}
          />
        }
        footerContent={<></>}
      />
    </div >
  );
};

export default TikTokIndex;
